import { useDroppable } from '@dnd-kit/core';

interface DroppableZoneProps {
  id: string;
  children: (isOver: boolean) => React.ReactNode;
}

const DroppableZone = ({ id, children }: DroppableZoneProps) => {
  const { isOver, setNodeRef } = useDroppable({ id });
  return <div ref={setNodeRef}>{children(isOver)}</div>;
};

export default DroppableZone;
